import { isDefined } from '@fabric-app/utils/guards';
import { getSimilarity } from '@fabric-app/utils/text';
import { visit } from '../../../node_modules/unist-util-visit/lib/index.js';
import { SKIP } from '../../../node_modules/unist-util-visit-parents/lib/index.js';
import { toString } from '../../../node_modules/mdast-util-to-string/lib/index.js';

const remarkRemoveTargetTitle = (options) => {
  const { title } = options;
  const contentThreshold = options.contentThreshold ?? 0.2;
  const minimumSimilarity = options.minimumSimilarity ?? 0.9;
  if (!title) return () => {
  };
  return (tree) => {
    const treeEnd = tree.position?.end.offset;
    if (!treeEnd) return;
    visit(tree, "heading", (node, index, parent) => {
      if (!node || !isDefined(index) || !parent) return [
        SKIP,
        index
      ];
      const headingStart = node.position?.start.offset;
      if (!isDefined(headingStart)) return [
        SKIP,
        index
      ];
      if (headingStart < treeEnd * contentThreshold) {
        const text = toString(node);
        const similarity = getSimilarity(text, title);
        if (similarity > minimumSimilarity) {
          parent.children.splice(index, 1);
          return [
            SKIP,
            index
          ];
        }
      }
    });
  };
};

export { remarkRemoveTargetTitle };
//# sourceMappingURL=remarkRemoveTargetTitle.js.map
